import { useEffect } from "react";

const Message = ({ toastObject, setToastObject }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setToastObject({});
    }, 4000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  return (
    <tr className="fancy-quick-tr">
      <td colspan={7}>
        <dl
          id="classWrap"
          className={`quick_bet-wrap quick_bet-message ${toastObject?.type}`}
        >
          <dd id="info">
            <strong id="header">{toastObject?.message}</strong>
            <a
              onClick={(e) => {
                e.stopPropagation();
                setToastObject({});
              }}
              id="close"
              className="btn-close"
              style={{ cursor: "pointer" }}
            >
              Close
            </a>
          </dd>
        </dl>
      </td>
    </tr>
  );
};

export default Message;
